import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import styled from "styled-components";
import SearchIcon from "../../../assets/images/BotagAIIcon.svg";
import SupportHeaderOne from "../../../assets/images/support-header-one.png";
import SupportHeaderTwo from "../../../assets/images/support-header-two.png";

const StyledPage = styled.div`
    &.frame-313358,
    &.frame-313358 * {
        box-sizing: border-box;
    }
    &.frame-313358 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313346 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }
    .frame-313282 {
        background: linear-gradient(90deg, rgba(32, 39, 51, 1) 0%, rgba(43, 48, 56, 1) 100%);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 80px;
        position: relative;
        overflow: hidden;
    }
    .quick-message-4 {
        width: 490px;
        position: absolute;
        height: 264px;
        left: -179px;
        rotate: 19deg;
        border: 4px solid rgb(51, 58, 68);
        border-radius: 10px;
        box-shadow: rgba(0, 0, 0, 0.25) 20px -20px 20px 20px;
        top: -34px;
    }
    .quick-message-5 {
        width: 490px;
        position: absolute;
        height: 304px;
        right: -190px;
        rotate: 325deg;
        border: 4px solid #333a44;
        border-radius: 10px;
        box-shadow: -20px -20px 20px 20px rgba(0, 0, 0, 0.25);
    }
    .frame-313363 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .hello-petter-how-can-we-help-you {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 28px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-49 {
        background: #10141b;
        border-radius: 5px;
        padding: 6px 4px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 522px;
        height: 46px;
        position: relative;
    }
    .search-for-questions {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: left;
        font-family: "Roboto-Italic", sans-serif;
        font-size: 15px;
        font-weight: 400;
        font-style: italic;
        position: relative;
        flex: 1;
        height: 100%;
        width: 100%;
        background: transparent;
        outline: none;
        border: none;
    }
    .search-for-questions.has-value {
        font-style: normal;
        color: #00bb00;
    }
    .frame-313350 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        width: 34px;
        height: 34px;
        cursor: pointer;
        position: relative;
    }
    .search-md {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-313351 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .heading-4-total-visitors {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        color: #00aeef;
    }
`;

/**
 * @param {string} searchQuery - The current search query.
 * @param {function} setSearchQuery - Function to update the search query.
 * @param {function} onSearch - Function to handle the search action.
 * @param {boolean} showResults - Flag to show or hide the search results.
 */
export default function SupportHeader({ tmpSearchQuery, setTmpSearchQuery, onSearch, showResults, showResultDetails }) {
    return (
        <StyledPage className="frame-313358">
            <div className="frame-313346">
                <div className="frame-313282">
                    <img className="quick-message-4" src={SupportHeaderOne} alt="" />
                    <img className="quick-message-5" src={SupportHeaderTwo} alt="" />
                    <div className="frame-313363">
                        <div className="frame-49">
                            <input
                                type="text"
                                className={`search-for-questions ${tmpSearchQuery ? "has-value" : ""}`}
                                placeholder="Ask Botag AI"
                                value={tmpSearchQuery}
                                onChange={e => setTmpSearchQuery(e.target.value)}
                                // onKeyPress={e => {
                                //     if (e.key === "Enter") {
                                //         onSearch();
                                //     }
                                // }}
                            />
                            <div
                                className="frame-313350" //onClick={() => onSearch()}
                            >
                                <img className="search-md" src={SearchIcon} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showResults && (
                <div className="frame-313351">
                    <div className="heading-4-total-visitors">SUPPORT</div>
                    <ChevronRight className="chevron-right" />
                    <div className="heading-4-total-visitors">
                        {showResultDetails ? "How BOtag syncs with your store’s POS" : "SEARCH RESULTS"}
                    </div>
                </div>
            )}
        </StyledPage>
    );
}
